import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";

export const useSubscription = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    return api.get("/billing/subscription")
      .then(({ data }) => setData(data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const plans = data?.plans || [];
  const effectivePlan = data?.effective_plan || data?.subscription?.plan || "free";
  const currentPlan = plans.find((p) => p.id === effectivePlan) || null;
  const sub = data?.subscription || null;

  let trialDaysLeft = null;
  if (sub?.trial_ends_at) {
    const diff = new Date(sub.trial_ends_at) - new Date();
    trialDaysLeft = Math.max(0, Math.ceil(diff / 86400000));
  }

  return { data, loading, reload: load, plans, effectivePlan, currentPlan, sub, trialDaysLeft };
};
